import { WA_MSG, WHATSAPP_DISPLAY, WHATSAPP_PHONE_LABEL, whatsappUrl } from '../lib/whatsapp.js';

export default function CTA() {
  return (
    <section id="comecar" className="relative overflow-hidden bg-ink-soft py-24 lg:py-28">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_70%_30%,rgba(201,162,122,0.12),transparent_50%)]" />
      <div className="relative mx-auto max-w-content px-6 lg:px-8">
        <div className="max-w-2xl">
          <h2 className="font-display text-3xl font-bold tracking-tight text-bone sm:text-5xl text-balance">
            Abra o Hbarber na sua barbearia.
          </h2>
          <p className="mt-5 max-w-md text-base leading-relaxed text-mist">
            Fale com {WHATSAPP_DISPLAY} no WhatsApp e escolha o plano certo para a sua loja.
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href={whatsappUrl(WA_MSG.general)}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex rounded-md bg-copper px-6 py-3 text-sm font-semibold text-ink transition-colors hover:bg-copper-soft active:scale-[0.98]"
            >
              Chamar no WhatsApp
            </a>
            <span className="text-sm text-mist">{WHATSAPP_PHONE_LABEL}</span>
          </div>
        </div>
      </div>
    </section>
  );
}
